<style scoped>
    .mis-table td, .mis-table th{
        padding: 5px;
    }
    .ivu-chart-circle {
        vertical-align: middle;
    }
    .circle-text{
        display: inline-block;
        transform: scale(0.8,0.8);
    }
    .sell-title{
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
    }
    .blind-area-table{
        width: 300px;
    }
    .blind-area-table th{
        padding: 1px;
    }
</style>
<template>
  <div class="container">
    <div
      v-if="cur_customer.has_unripe_options"
      class="line text-large"
    >
      你的期权尚未成熟，暂无法参与本次回购
    </div>
    <div
      v-if="!cur_customer.has_unripe_options && cur_customer.has_options"
      class="line"
    >
      <h2>
        <!--<span>期权查看(升级中, 暂时无法查询)</span>-->
        <span>期权查看</span>
        <!--<a href="/static/期权Keynote.pdf" target="_blank">期权Keynote.pdf</a>-->
      </h2>
      <!--<div class="line" v-if="false">-->
      <div class="line">
        <Button
          type="warning"
          size="small"
          :loading="getting_sms"
          :disabled="sms_timeout > 0 || getting_sms"
          @click="getSmsCode"
        >
          <span>{{ sms_btn_text }}</span>
        </Button>
        <i-input
          v-model="sms_code"
          size="small"
          placeholder="输入验证码"
          style="width: 100px"
          @on-enter="getMyOption"
        />
        <Button
          type="primary"
          size="small"
          :loading="getting_option"
          @click="getMyOption"
        >
          <span>获取期权信息</span>
        </Button>
      </div>
      <div
        v-if="options.length"
        class="line"
      >
        <table class="mis-table text-center">
          <tr>
            <th>期权起始日期</th>
            <th>期权数量</th>
            <th>摊薄比例</th>
            <th>摊薄/回购后数量</th>
            <th>成熟比例</th>
            <th>成熟数量</th>
            <th>
              <Tooltip
                transfer
                placement="top"
              >
                <span>行权价格</span>
                <Icon type="ios-help" />
                <span slot="content">
                  买入价
                </span>
              </Tooltip>
            </th>
            <th>
              <Tooltip
                transfer
                placement="top"
              >
                <span>公司估值</span>
                <Icon type="ios-help" />
                <span slot="content">
                  卖出价
                </span>
              </Tooltip>
            </th>
            <th>期权总价值</th>
            <th>已成熟总价值</th>
          </tr>
          <tr
            v-for="option in options"
            :key="option.id"
          >
            <td>{{ option.start_date }}</td>
            <td>{{ option.option_count }}</td>
            <td>
              <i-circle
                :size="32"
                :percent="option.dilute_scale * 100"
              >
                <span class="circle-text">{{ option.dilute_scale * 100 }}%</span>
              </i-circle>
            </td>
            <td>{{ option.dilute_count }}</td>
            <td>
              <i-circle
                :size="32"
                :percent="option.ripe_scale * 100"
              >
                <span class="circle-text">{{ option.ripe_scale * 100 }}%</span>
              </i-circle>
            </td>
            <td>{{ option.ripe_count }}</td>
            <td>￥{{ option.buying_price }}</td>
            <td>￥{{ option.selling_price }}</td>
            <td>￥{{ option.option_total_price }}</td>
            <td>￥{{ option.ripe_total_price }}</td>
          </tr>
        </table>
      </div>
      <div
        v-if="false"
        class="hr"
      />
      <div
        v-if="options.length && false"
        class="line"
      >
        <h2 class="sell-title text-bold">
          我要卖出
        </h2>
        <div class="line">
          <table class="mis-table text-center">
            <tr>
              <th width="120">
                *拟卖出股数
              </th>
              <th width="120">
                *拟卖出期权总价值
              </th>
              <th width="120">
                *拟卖出期权后实得
              </th>
              <th>期权产生个税</th>
              <th>备注</th>
              <th>计税基础</th>
              <th>个税</th>
              <th>年终奖</th>
              <th>年终奖个税</th>
            </tr>
            <tr>
              <td>
                <i-input
                  v-model="option_order.selling_count"
                  class="order-input"
                  size="small"
                  number
                  @on-change="calcOptionOrder('selling_count')"
                />
              </td>
              <td>
                <i-input
                  v-model="option_order.total_price"
                  class="order-input"
                  size="small"
                  number
                  @on-change="calcOptionOrder('total_price')"
                />
              </td>
              <td>
                <i-input
                  v-model="option_order.net_price"
                  class="order-input"
                  size="small"
                  number
                  @on-change="calcOptionOrder('net_price')"
                />
              </td>
              <td>￥{{ option_order.option_tax }}</td>
              <td>
                <span v-html="option_order.desc" />
              </td>
              <td>￥{{ option_order.tax_base }}</td>
              <td>￥{{ option_order.total_tax }}</td>
              <td>￥{{ option_order.annual_bonus }}</td>
              <td>￥{{ option_order.bonus_tax }}</td>
            </tr>
          </table>
          <div class="color-error">
            请输入任一带*的项. 订单可多次提交, 每年只保留最后一次提交的订单.
          </div>
          <Poptip
            transfer
            confirm
            placement="bottom"
            :title="submit_order_confirm_title"
            @on-ok="submitOrder"
          >
            <Button
              type="primary"
              :loading="submitting_order"
            >
              <span>提交订单</span>
            </Button>
          </Poptip>
          <div class="line">
            <span>个税盲区(拟卖出股权的总价值)</span>
            <span
              v-if="order_alert"
              class="color-error text-bold"
            >已落入个税盲区, 建议修改</span>
            <table class="mis-table text-center blind-area-table">
              <tr>
                <th width="150">
                  上限
                </th>
                <th width="150">
                  下限
                </th>
              </tr>
              <tr
                v-for="(blind_area, index) in blind_areas"
                :key="index"
                :class="{'color-error': blind_area.alert}"
              >
                <td>{{ blind_area.start }}</td>
                <td>{{ blind_area.end }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div
          v-if="submitted_orders.length"
          class="line"
        >
          <div class="text-bold">
            已提交订单
          </div>
          <table class="mis-table text-center">
            <tr>
              <th>年份</th>
              <th>拟卖出股数</th>
              <th>拟卖出期权总价值</th>
              <th>拟卖出期权后实得</th>
              <th>期权产生个税</th>
              <th>备注</th>
              <th>操作</th>
              <!--<th>计税基础</th>
                            <th>个税</th>
                            <th>年终奖</th>
                            <th>年终奖个税</th>-->
            </tr>
            <tr
              v-for="(order,index) in submitted_orders"
              :key="order.id"
            >
              <td>{{ order.year }}</td>
              <td>{{ order.selling_count }}</td>
              <td>￥{{ order.total_price }}</td>
              <td>￥{{ order.net_price }}</td>
              <td>￥{{ order.option_tax }}</td>
              <td>
                <span v-html="order.desc" />
              </td>
              <td>
                <Poptip
                  v-if="isFirstOrder(index)"
                  transfer
                  confirm
                  placement="left"
                  title="你确定要删除订单吗?"
                  @on-ok="deleteOrder(order, index)"
                >
                  <Button
                    size="small"
                    icon="md-close"
                    :loading="deleting_order"
                  />
                </Poptip>
              </td>
              <!--<td>￥{{order.tax_base}}</td>
                            <td>￥{{order.total_tax}}</td>
                            <td>￥{{order.annual_bonus}}</td>
                            <td>￥{{order.bonus_tax}}</td>-->
            </tr>
          </table>
        </div>
        <div class="color-grey">
          以上数据如有疑问, 请咨询财务.
        </div>
      </div>
    </div>
    <Spin
      v-if="loading"
      size="large"
      fix
    />
  </div>
</template>
<script route="/mine/options">
  import Util from '../../libs/util';
  import FinUtil from '../../libs/fin_util';
  export default {
    /* router_info_start */
    router_info: {
      path:'/mine/options',
      noChkout: true
    },
    /* router_info_end */

    data() {
      return {
        loading: false,
        customer: {careers: [], home_pages: [], interests: []},
        has_option: false,
        getting_sms: false,
        sms_timeout: 0,
        getting_option: false,
        sms_code: '',
        fake_options: [
          {
            account: "马良焰",
            selling_price: "1500.0",
            created_at: "2018-02-09T10:18:19.000+08:00",
            customer_id: 202,
            dilute_count: 20,
            dilute_scale: "1.0",
            buying_price: "11.87",
            id: 950,
            mobile: "18581856308",
            option_count: 20,
            option_total_price: "30000",
            ripe_count: 5,
            ripe_scale: "0.25",
            ripe_total_price: "7500.00",
            sms_code: "610024",
            sms_send_at: "2018-02-09T14:34:45.000+08:00",
            start_date: "2017-06-30",
            updated_at: "2018-02-09T14:34:45.000+08:00",
          },
          {
            account: "马良焰",
            selling_price: "1500.0",
            created_at: "2018-02-09T10:18:19.000+08:00",
            customer_id: 202,
            dilute_count: 17,
            dilute_scale: "0.85",
            buying_price: "11.87",
            id: 951,
            mobile: "18581856308",
            option_count: 20,
            option_total_price: "30000",
            ripe_count: 10,
            ripe_scale: "0.5",
            ripe_total_price: "15000.0",
            sms_code: "610024",
            sms_send_at: "2018-02-09T14:34:45.000+08:00",
            start_date: "2017-06-30",
            updated_at: "2018-02-09T14:34:45.000+08:00",
          }
        ],
        options: [],
        option_columns: [
          {
            title: '期权成熟起始日',
            align: 'center',
            width: 120,
            fixed: 'left',
            key: 'start_date'
          },
          {
            title: '期权数量',
            align: 'center',
            width: 100,
            key: 'option_count'
          },
          {
            title: '摊薄比例',
            align: 'center',
            width: 80,
            key: 'dilute_scale',
            render: (h, params) => {
              const row = params.row;
              if (row.dilute_scale.indexOf('%') > -1) {
                return h('div', row.dilute_scale);
              } else {
                const scale = math.eval(`${row.dilute_scale} * 100`);
                return h('div', `${scale}%`);
              }
            }
          },
          {
            title: '摊薄/回购后期权数量',
            align: 'center',
            width: 120,
            key: 'dilute_count'
          },
          {
            title: '成熟比例',
            align: 'center',
            width: 80,
            key: 'ripe_scale',
            render: (h, params) => {
              const row = params.row;
              if (row.ripe_scale.indexOf('%') > -1) {
                return h('div', row.ripe_scale);
              } else {
                const scale = math.eval(`${row.ripe_scale} * 100`);
                return h('div', `${scale}%`);
              }
            }
          },
          {
            title: '已成熟期权数量',
            width: 120,
            align: 'center',
            key: 'ripe_count'
          },
          {
            title: '行权价格(买入价)',
            align: 'center',
            width: 120,
            key: 'buying_price',
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.buying_price))
            }
          },
          {
            title: '每股估值(卖出价)',
            align: 'center',
            width: 120,
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.selling_price));
            }
          },
          {
            title: '期权总价值',
            align: 'center',
            width: 100,
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.option_total_price));
            }
          },
          {
            title: '已成熟期权总价值',
            align: 'center',
            width: 140,
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.ripe_total_price));
            }
          }
        ],
        option_order: {
          customer_id: 0,
          year: '',
          buying_price: 0,
          selling_count: 0,
          selling_price: 0,
          total_price: 0,
          // extra calc
          net_price: 0,
          option_tax: 0,
          tax_base: 0,
          total_tax: 0,
          annual_bonus: 0,
          bonus_tax: 0,
          desc: ''
        },
        order_alert: false,
        submitted_orders: [],
        submitting_order: false,
        deleting_order: false,
        blind_areas: [],
        calc_option_timer: 0
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      sms_btn_text() {
        if (!this.getting_sms && this.sms_timeout === 0) {
          return '获取验证码';
        }
        if (this.sms_timeout > 0) {
          return `${this.sms_timeout} S`;
        }
        return '获取中...';
      },
      submit_order_confirm_title() {
        const title = '您确认要提交订单吗?';
        // if(this.submitted_orders.length){
        //     title += ' 提交后将覆盖当年订单.'
        // }
        return title;
      },
      first_option() {
        if (this.options.length) {
          return this.options[0];
        } else {
          return false;
        }
      },
      option_sell_price() {
        if (this.options.length) {
          const first_option = this.options[0];
          const buying_price = first_option.buying_price || 0;
          const selling_price = first_option.selling_price || 0;
          return selling_price - buying_price;
        } else {
          return 0;
        }
      }
    },
    created() {
      //
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.checkHasOption();
      },
      checkHasOption() {
        Util.ajax.get(Util.api.check_has_option).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          if (data.code === 1) {
            this.has_option = true;
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      getSmsCode() {
        Util.ajax.get(Util.api.option_sms_code).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          if (data.code === 1) {
            this.sms_timeout = 120;
            this.sms_timer = setInterval(() => {
              this.sms_timeout--;
              if (this.sms_timeout <= 0) {
                clearInterval(this.sms_timer);
              }
            }, 1000);
            this.$Message.success('发送短信成功!');
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.error({title: '提示', content: e.message});
        });
      },
      getMyOption() {
        if (!this.sms_code.trim()) {
          this.$Message.error('请输入验证码查看');
          return;
        }
        this.getting_option = true;
        Util.ajax.get(Util.api.my_option, {
          params: {
            sms_code: this.sms_code
          }
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.getting_option = false;
          if (data.code === 1) {
            this.options = [];
            data.options.forEach((option) => {
              //预处理(卖出数量 < 25% and < ripe_count)
              option.calc_price = math.eval(`${option.selling_price} - ${option.buying_price}`).toFixed(2);
              const max_sell_count = option.dilute_count * 0.25;
              option.max_sell_count = math.eval(`${option.ripe_count} < ${max_sell_count}`) ? option.ripe_count : max_sell_count;
              option.max_sell_price = math.eval(`${option.max_sell_count} * ${option.calc_price}`).toFixed(2);
              this.options.push(option);
            });
            this.option_order.annual_bonus = data.bonus;
            this.genBlindAreas2019();
            this.getSubmittedOptionOrders();
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.getting_option = false;
          this.$Modal.error({title: '提示', content: e.message});
        });
      },
      genBlindAreas2018() {
        const calc_base = [
          [18000.00, 19283.33],
          [54000.00, 60187.50],
          [108000.00, 114600.00],
          [420000.00, 447500.00],
          [660000.00, 706538.46],
          [960000.00, 1120000.00]
        ];
        this.blind_areas = [];
        const bonus = this.option_order.annual_bonus;
        calc_base.forEach((base) => {
          const start = math.eval(`${base[0]} - ${bonus}`).toFixed(2);
          const end = math.eval(`${base[1]} - ${bonus}`).toFixed(2);
          this.blind_areas.push({start: start, end: end, alert: false});
        });
      },
      genBlindAreas2019() {
        const calc_base = [
          [36000.00, 38566.67],
          [144000.00, 160500.00],
          [300000.00, 318333.33],
          [420000.00, 447500.00],
          [660000.00, 706538.46],
          [960000.00, 1120000.00]
        ];
        this.blind_areas = [];
        const bonus = this.option_order.annual_bonus;
        calc_base.forEach((base) => {
          const start = math.eval(`${base[0]} - ${bonus}`).toFixed(2);
          const end = math.eval(`${base[1]} - ${bonus}`).toFixed(2);
          this.blind_areas.push({start: start, end: end, alert: false});
        });
      },
      getSubmittedOptionOrders() {
        Util.ajax.get(Util.api.my_option_order).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          if (data.code === 1) {
            this.submitted_orders = [];
            data.orders.forEach((order) => {
              this.submitted_orders.push(order);
            });
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.error({title: '提示', content: e.message});
        });
      },
      calcOptionOrder(change_key) {
        let max_sell_count = 0;
        let max_sell_price = 0;
        this.options.forEach((option) => {
          max_sell_count = math.eval(`${max_sell_count} + ${option.max_sell_count}`).toFixed(2);
          max_sell_price = math.eval(`${max_sell_price} + ${option.max_sell_price}`).toFixed(2);
        });
        clearTimeout(this.calc_option_timer);
        try {
          this.option_order.bonus_tax = FinUtil.calcBonusTax20190213(this.option_order.annual_bonus);
          switch (change_key) {
          case 'selling_count':
            if (math.eval(`${this.option_order.selling_count} > ${max_sell_count}`)) {
              setTimeout(() => {
                this.option_order.selling_count = max_sell_count;
              }, 500);
              console.log('exceed...');
              this.$Message.warning(`最大卖出数量不能超过: ${max_sell_count}`);
            }
            this.option_order.total_price = this.getTotalPriceBySellingCount(this.option_order.selling_count);
            this.option_order.tax_base = math.eval(`${this.option_order.total_price} + ${this.option_order.annual_bonus}`).toFixed(2);
            this.option_order.total_tax = FinUtil.calcBonusTax20190213(this.option_order.tax_base);
            this.option_order.option_tax = math.eval(`${this.option_order.total_tax} - ${this.option_order.bonus_tax}`).toFixed(2);
            this.option_order.net_price = math.eval(`${this.option_order.total_price} - ${this.option_order.option_tax}`).toFixed(2);
            break;
          case 'total_price':
            if (math.eval(`${this.option_order.total_price} > ${max_sell_price}`)) {
              setTimeout(() => {
                this.option_order.total_price = max_sell_price;
              }, 500);
              this.$Message.warning(`卖出总价值不能超过: ${max_sell_price}`);
            }
            this.option_order.selling_count = this.getSellingCountByTotalPrice(this.option_order.total_price);
            this.calc_option_timer = setTimeout(() => {
              this.calcOptionOrder('selling_count');
            }, 800);
            //this.option_order.tax_base = math.eval(`${this.option_order.total_price} + ${this.option_order.annual_bonus}`).toFixed(2);
            //this.option_order.total_tax = FinUtil.calcBonusTax20190213(this.option_order.tax_base);
            //this.option_order.option_tax = math.eval(`${this.option_order.total_tax} - ${this.option_order.bonus_tax}`).toFixed(2);
            //this.option_order.net_price = math.eval(`${this.option_order.total_price} - ${this.option_order.option_tax}`).toFixed(2);
            break;
          case 'net_price':
            this.option_order.tax_base = FinUtil.calcTaxBaseByNetOptionPrice20190213(this.option_order.net_price, this.option_order.annual_bonus, this.option_order.bonus_tax);
            this.option_order.total_tax = FinUtil.calcBonusTax20190213(this.option_order.tax_base);
            this.option_order.option_tax = math.eval(`${this.option_order.total_tax} - ${this.option_order.bonus_tax}`).toFixed(2);
            this.option_order.total_price = math.eval(`${this.option_order.net_price} + ${this.option_order.option_tax}`).toFixed(2);
            this.calc_option_timer = setTimeout(() => {
              this.calcOptionOrder('total_price');
            }, 800);
            //this.option_order.selling_count = math.eval(`${this.option_order.total_price || 0} / ${calc_price}`).toFixed(2);
            break;
          default:
            console.error('error input type');
            break;
          }
          this.order_alert = FinUtil.lookup(this.option_order.tax_base, FinUtil.tax_base_blind_area_2019, [false, true, false, true, false, true, false, true, false, true, false, true, false])
          this.blind_areas.forEach((area) => {
            const total_price = this.option_order.total_price;
            area.alert = math.eval(`${total_price} >= ${area.start}`) && math.eval(`${total_price} < ${area.end}`);
          });
        } catch (e) {
          console.log(e.message);
          //this.$Message.error(e.message);
        }
      },
      getTotalPriceBySellingCount(count) {
        let left_count = math.eval(`${count} * 1`).toFixed(2);
        let price = 0;
        this.option_order.desc = '';
        this.options.forEach((option) => {
          if (math.eval(`${left_count} > 0`)) {
            if (math.eval(`${option.max_sell_count} >= ${left_count}`)) {
              price = math.eval(`${price} + ${left_count} * ${option.calc_price}`).toFixed(2);
              this.option_order.desc += `<p>${option.start_date}授予期权卖出 ${left_count} 股</p>`;
            } else {
              price = math.eval(`${price} + ${option.max_sell_price}`).toFixed(2);
              this.option_order.desc += `<p>${option.start_date}授予期权卖出 ${option.max_sell_count} 股</p>`;
            }
            left_count = math.eval(`${left_count} - ${option.max_sell_count}`).toFixed(2);
          }
        });
        return price;
      },
      getSellingCountByTotalPrice(price) {
        let left_price = math.eval(`${price} * 1`).toFixed(2);
        let count = 0;
        this.option_order.desc = '';
        this.options.forEach((option) => {
          if (math.eval(`${left_price} > 0`)) {
            if (math.eval(`${option.max_sell_price} >= ${left_price}`)) {
              const option_sell_count = math.eval(`${left_price} / ${option.calc_price}`).toFixed(2);
              count = math.eval(`${count} + ${option_sell_count}`).toFixed(2);
              this.option_order.desc += `<p>${option.start_date}授予期权卖出 ${option_sell_count} 股</p>`;
            } else {
              count = math.eval(`${count} + ${option.max_sell_count}`).toFixed(2);
              this.option_order.desc += `<p>${option.start_date}授予期权卖出 ${option.max_sell_count} 股</p>`;
            }
            left_price = math.eval(`${left_price} - ${option.max_sell_price}`).toFixed(2);
          }
        });
        return count;
      },
      checkOrderValid() {
        let err_msg = '';
        if (this.options.length === 0) {
          err_msg += `<p>没有获取到期权信息, 不能提交订单.</p>`;
        }
        if (math.eval(`${this.option_order.selling_count} <= 0`)) {
          err_msg += `<p>卖出数量不能为0</p>`;
        }
        let option_total_count = 0;
        this.options.forEach((option) => {
          option_total_count = math.eval(`${option_total_count} + ${option.dilute_count}`).toFixed(2);
        });
        let ripe_total_count = 0;
        this.options.forEach((option) => {
          ripe_total_count = math.eval(`${ripe_total_count} + ${option.ripe_count}`).toFixed(2);
        });
        // 不能卖出超过成熟的期权数量
        if (this.option_order.selling_count > ripe_total_count) {
          err_msg += `<p>不能卖出超过成熟的期权数量</p>`;
        }
        // 不能卖出超过期权数量的1/4
        if (this.option_order.selling_count > option_total_count / 4) {
          err_msg += `<p>不能卖出超过期权数量的四分之一</p>`;
        }
        // 卖出的期权价值不能超过200w
        if (math.eval(`${this.option_order.total_price} > 2000000`)) {
          err_msg += `<p>卖出的期权价值不能超过 200 万</p>`;
        }
        if (err_msg) {
          this.$Modal.error({
            title: '提示',
            content: err_msg
          });
          return false;
        }
        return true;
      },
      submitOrder() {
        if (!this.checkOrderValid()) return;
        this.submitting_order = true;
        Util.ajax.post(Util.api.submit_option_order, this.option_order).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.submitting_order = false;
          if (data.code === 1) {
            this.$Message.success('提交订单成功!');
            this.submitted_orders = [];
            data.orders.forEach((order) => {
              this.submitted_orders.push(order);
            });
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.submitting_order = false;
          this.$Modal.error({title: '提示', content: e.message});
        });
      },
      isFirstOrder(index) {
        return index === 0;
      },
      deleteOrder(order, index) {
        this.deleting_order = true;
        Util.ajax.post(Util.api.delete_option_order, order).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.deleting_order = false;
          if (data.code === 1) {
            this.$Message.success('删除订单成功!');
            this.submitted_orders.splice(index, 1);
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.deleting_order = false;
          this.$Modal.error({title: '提示', content: e.message});
        });
      }
    }
  }
</script>
